var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _path3, _path4, _g9, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1123,
    height: 1083,
    viewBox: "0 0 1123 1083",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.705 248.458L331.526 291.804L154.076 188.856L231.964 145.51L406.705 248.458Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.705 477.381L331.526 520.727L154.076 417.779L231.964 374.433L406.705 477.381Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.279 477.381L331.1 520.727L153.65 417.779L231.539 374.433L406.279 477.381Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.525 291.805V520.728",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.643 145.51V374.433L154.152 417.705V188.781",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.709 247.705V476.629",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.055 333.045L181.875 376.391L4.42578 273.443L82.314 230.097L257.055 333.045Z",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.055 561.967L181.875 605.314L4.42578 502.366L82.314 459.02L257.055 561.967Z",
    stroke: "#231F20",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.629 561.967L181.45 605.314L4 502.366L81.8882 459.02L256.629 561.967Z",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.875 376.392V605.315",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9922 230.097V459.02L4.50195 502.292V273.368",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.059 332.292V561.216",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M886.041 362.92L810.862 406.266L633.412 303.318L711.3 259.972L886.041 362.92Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.041 591.842L810.862 635.189L633.412 532.241L711.3 488.895L886.041 591.842Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.615 591.842L810.436 635.189L632.986 532.241L710.875 488.895L885.615 591.842Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.861 406.267V635.19",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.979 259.972V488.895L633.488 532.167V303.243",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.045 362.167V591.091",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119 492.079L1043.82 535.425L866.369 432.477L944.257 389.131L1119 492.079Z",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119 721.002L1043.82 764.348L866.369 661.4L944.257 618.054L1119 721.002Z",
    stroke: "#231F20",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.57 721.002L1043.39 764.348L865.943 661.4L943.832 618.054L1118.57 721.002Z",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.82 535.426V764.35",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.936 389.131V618.055L866.445 661.326V432.402",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119 491.326V720.25",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.832 208.093L543.011 251.44L720.461 148.492L642.573 105.146L467.832 208.093Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.832 437.016L543.011 480.363L720.461 377.415L642.573 334.068L467.832 437.016Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.258 437.016L543.437 480.363L720.887 377.415L642.998 334.068L468.258 437.016Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.01 251.44V480.364",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.896 105.146V334.069L720.387 377.34V148.417",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.832 207.341V436.265",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.385 104.948L377.564 148.294L555.014 45.3465L477.125 2L302.385 104.948Z",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.385 333.871L377.564 377.217L555.014 274.269L477.125 230.923L302.385 333.871Z",
    stroke: "#231F20",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.811 333.871L377.99 377.217L555.439 274.269L477.551 230.923L302.811 333.871Z",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.562 148.295V377.219",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.449 2V230.924L554.939 274.195V45.2712",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.385 104.195V333.119",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.127 808.102L554.306 851.449L731.756 748.501L653.868 705.154L479.127 808.102Z",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.127 1037.03L554.306 1080.37L731.756 977.424L653.868 934.077L479.127 1037.03Z",
    stroke: "#231F20",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.553 1037.03L554.732 1080.37L732.182 977.424L654.293 934.077L479.553 1037.03Z",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.305 851.449V1080.37",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.191 705.154V934.078L731.682 977.349V748.426",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.127 807.35V1036.27",
    stroke: "white",
    strokeWidth: 3.32179,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.525 705.43L406.704 748.777L584.154 645.829L506.266 602.482L331.525 705.43Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.525 934.353L406.704 977.7L584.154 874.752L506.266 831.405L331.525 934.353Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.953 934.353L407.132 977.7L584.582 874.752L506.694 831.405L331.953 934.353Z",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.705 748.777V977.701",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.59 602.482V831.406L584.08 874.677V645.754",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.525 704.678V933.601",
    stroke: "white",
    strokeWidth: 3.32183,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M440.436 520.915C422.757 529.104 417.653 527.022 399.164 533.571C389.54 536.981 374.425 542.334 359.543 554.482C347.342 564.442 334.363 575.037 333.13 591.902C332.05 606.66 340.382 620.527 350.189 628.221C359.249 635.329 366.579 634.824 389.259 639.777C389.26 639.777 409.17 644.124 431.081 651.333C467.077 663.175 467.798 674.397 505.92 688.752C525.949 696.295 539.206 701.092 556.546 698.107C560.6 697.409 582.812 693.585 596.167 675.545C598.117 672.911 600.428 667.7 604.971 657.386C615.203 634.155 620.319 622.539 619.829 616.665C618.646 602.472 607.029 592.869 591.214 579.796C582.011 572.188 573.339 567.57 555.996 558.334C540.196 549.921 532.143 545.702 524.629 545.127C521.486 544.887 514.23 544.699 504.819 541.826C504.818 541.825 500.212 540.419 496.015 538.524C476.897 529.893 473.137 513.772 460.796 512.11C455.166 511.352 454.312 514.487 440.436 520.915Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M829.093 769.093C819.75 777.755 810.678 775.865 797.177 780.099C789.622 782.468 769.391 788.811 765.26 803.761C762.33 814.367 767.976 827.589 777.917 834.027C790.083 841.905 806.283 838.068 815.336 830.725C828.638 819.935 823.635 803.907 837.348 796.607C844.409 792.848 846.805 796.529 857.158 792.755C869.213 788.361 883.4 777.014 881.37 767.442C879.651 759.331 866.957 755.654 861.01 754.786C849.492 753.103 840.482 758.626 837.348 760.839C832.988 763.917 832.737 765.715 829.093 769.093Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M758.106 688.752C754.484 697.572 766.155 703.649 766.911 719.568C767.271 727.157 764.763 728.823 754.804 751.484C746.817 769.659 741.598 781.687 738.296 796.608C735.995 806.999 733.985 816.081 734.994 827.424C736.501 844.363 745.642 876.454 770.212 883.553C793.085 890.162 815.975 871.253 819.738 868.145C828.291 861.079 836.418 850.527 840.649 845.033C851.638 830.763 851.361 827.087 858.258 823.021C866.224 818.326 874.744 818.426 891.275 818.619C907.325 818.807 909.175 821.081 914.387 818.619C925.482 813.378 931.59 796.225 928.695 782.3C925.364 766.284 910.79 757.754 900.08 751.484C885.558 742.984 869.454 738.925 845.051 732.774C831.734 729.418 826.03 728.613 820.839 722.869C812.943 714.134 817.254 706.165 808.732 694.254C807.052 691.906 799.225 680.966 785.62 678.846C775.593 677.284 761.547 680.376 758.106 688.752Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M805.153 738.277C798.28 740.97 799.116 745.974 787.269 756.986C778.441 765.193 776.754 763.55 769.385 770.744C764.578 775.436 756.114 783.699 752.876 796.882C749.995 808.611 752.719 818.253 755.077 826.598C757.489 835.132 759.351 841.722 765.533 847.233C773.582 854.41 783.535 854.797 786.994 854.937C807.819 855.781 822.726 839.693 823.863 838.429C833.984 827.173 831.183 819.411 842.022 812.015C843.675 810.887 844.475 810.566 861.833 805.137C883.561 798.34 887.942 797.08 892.374 792.205C893.945 790.476 898.905 784.857 899.252 776.522C899.646 767.097 893.881 760.498 892.099 758.637C888.129 754.491 883.391 752.408 873.939 750.108C854.122 745.285 850.487 748.486 834.319 744.88C816.375 740.879 813.028 735.191 805.153 738.277Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1016.81 807.533L777.888 945.289L213.951 618.12L461.48 480.364L1016.81 807.533Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M413.065 543.903C395.069 549.035 385.895 551.689 377.296 556.009C362.905 563.241 355.126 567.149 351.983 575.82C347.53 588.105 355.164 602.274 362.989 609.938C374.683 621.39 390.377 621.816 398.757 622.044C427.803 622.832 434.345 606.683 457.088 610.488C470.943 612.806 467.992 618.712 491.206 626.996C505.948 632.258 525.552 638.95 542.932 630.298C546.144 628.699 554.602 624.34 558.891 614.89C566.211 598.764 554.893 582.13 553.938 580.772C547.558 571.7 538.825 567.954 535.229 566.465C522.426 561.165 516.882 565.494 491.206 562.613C480.789 561.444 475.581 560.86 470.845 558.761C455.805 552.096 455.618 541.575 443.881 537.85C441.606 537.128 438.691 536.596 413.065 543.903Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M430.682 561.91C412.721 556.569 396.709 565.298 394.913 566.312C389.84 569.178 384.19 572.37 383.357 577.868C382.17 585.712 391.424 594.048 399.866 597.129C409.863 600.777 419.675 597.404 428.481 594.377C443.211 589.313 444.721 583.959 454.344 583.922C459.861 583.9 464.809 586.2 474.704 590.8C489.709 597.775 493.302 602.806 500.843 601.531C505.359 600.767 510.852 597.816 511.574 593.552C512.282 589.364 508.112 585.558 506.621 584.197C502.882 580.784 498.785 579.445 481.859 576.768C469.796 574.86 468.272 574.97 462.323 573.466C456.613 572.023 452.117 570.43 448.291 569.064C436.324 564.792 436.047 563.506 430.682 561.91Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M820.035 795.543C817.66 794.87 815.884 794.367 813.932 793.814C817.595 787.847 821.147 782.06 824.841 776.039C822.954 775.565 821.393 775.173 819.57 774.715C822.991 768.351 826.343 762.115 829.844 755.6C827.714 755.287 825.953 755.028 823.568 754.678C831.151 743.969 835.553 732 840.122 719.387C844.884 731.858 849.036 743.944 856.837 754.674C854.452 755.013 852.635 755.272 850.458 755.582C853.948 762.039 857.293 768.226 860.786 774.688C859.061 775.124 857.515 775.515 855.466 776.033C859.149 782.018 862.734 787.843 866.422 793.836C864.407 794.396 862.627 794.89 860.298 795.537C864.96 802.181 869.44 808.565 874.348 815.559H844.989V838.656H835.431V815.726H805.875C810.825 808.67 815.309 802.279 820.035 795.543Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 6.64365,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M757.392 830.905C753.391 829.772 750.4 828.924 747.114 827.993C753.282 817.942 759.264 808.196 765.487 798.056C762.307 797.257 759.679 796.597 756.609 795.826C762.37 785.108 768.015 774.605 773.912 763.633C770.324 763.106 767.358 762.67 763.343 762.08C776.113 744.043 783.527 723.885 791.222 702.642C799.242 723.645 806.235 744.001 819.374 762.072C815.357 762.644 812.297 763.08 808.63 763.602C814.508 774.477 820.141 784.897 826.024 795.781C823.12 796.515 820.516 797.173 817.064 798.046C823.268 808.126 829.306 817.937 835.518 828.03C832.124 828.973 829.125 829.806 825.203 830.895C833.055 842.085 840.6 852.837 848.866 864.617H799.419V903.516H783.321V864.897H733.543C741.88 853.014 749.433 842.249 757.392 830.905Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 6.64365,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M631.735 576.239C627.735 575.106 624.743 574.258 621.457 573.326C627.625 563.276 633.607 553.53 639.83 543.39C636.651 542.591 634.023 541.931 630.953 541.16C636.714 530.442 642.359 519.939 648.256 508.967C644.668 508.44 641.702 508.004 637.686 507.414C650.456 489.377 657.87 469.219 665.566 447.976C673.586 468.979 680.579 489.335 693.718 507.406C689.7 507.978 686.641 508.414 682.973 508.936C688.852 519.811 694.485 530.231 700.368 541.115C697.464 541.849 694.859 542.507 691.408 543.38C697.612 553.46 703.649 563.27 709.861 573.364C706.467 574.307 703.469 575.14 699.546 576.229C707.398 587.419 714.944 598.171 723.21 609.951H673.762V648.85H657.664V610.231H607.887C616.224 598.348 623.776 587.583 631.735 576.239Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 6.64365,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M595.307 640.699C592.932 640.025 591.155 639.522 589.204 638.969C592.866 633.002 596.418 627.215 600.113 621.194C598.225 620.72 596.665 620.328 594.842 619.87C598.262 613.506 601.614 607.27 605.116 600.755C602.985 600.442 601.224 600.184 598.84 599.833C606.422 589.124 610.824 577.155 615.394 564.542C620.155 577.013 624.308 589.099 632.109 599.829C629.723 600.168 627.907 600.427 625.729 600.737C629.22 607.194 632.564 613.381 636.057 619.843C634.333 620.279 632.786 620.67 630.737 621.188C634.421 627.173 638.006 632.998 641.694 638.991C639.679 639.551 637.898 640.046 635.569 640.693C640.232 647.336 644.712 653.721 649.619 660.715H620.26V683.811H610.702V660.881H581.146C586.097 653.825 590.581 647.434 595.307 640.699Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 6.64365,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M411.23 542.976C407.717 541.98 405.089 541.235 402.203 540.418C407.621 531.591 412.874 523.031 418.339 514.126C415.547 513.425 413.239 512.845 410.543 512.168C415.602 502.754 420.56 493.53 425.739 483.894C422.588 483.431 419.983 483.048 416.456 482.53C427.672 466.69 434.183 448.986 440.942 430.329C447.985 448.775 454.127 466.653 465.666 482.523C462.137 483.026 459.45 483.408 456.229 483.867C461.392 493.418 466.339 502.569 471.506 512.128C468.955 512.773 466.668 513.351 463.637 514.117C469.085 522.97 474.388 531.586 479.844 540.45C476.863 541.278 474.229 542.01 470.784 542.967C477.68 552.794 484.307 562.237 491.566 572.582H448.14V606.745H434.002V572.828H390.285C397.607 562.392 404.24 552.938 411.23 542.976Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 6.64365,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M360.386 564.01C356.386 562.876 353.394 562.028 350.108 561.097C356.276 551.047 362.258 541.3 368.481 531.161C365.301 530.362 362.673 529.702 359.603 528.931C365.364 518.213 371.009 507.71 376.906 496.737C373.318 496.21 370.352 495.774 366.337 495.184C379.107 477.148 386.521 456.99 394.216 435.746C402.236 456.75 409.23 477.106 422.368 495.177C418.351 495.749 415.291 496.184 411.624 496.706C417.503 507.582 423.135 518.002 429.019 528.885C426.114 529.62 423.51 530.278 420.058 531.15C426.262 541.231 432.3 551.041 438.512 561.134C435.118 562.077 432.119 562.91 428.197 564C436.049 575.189 443.594 585.942 451.86 597.721H402.413V636.62H386.315V598.001H336.537C344.874 586.118 352.427 575.354 360.386 564.01Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 6.64365,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.c21a70147c66c5641d4966516e8b07ab.svg";
export { ForwardRef as ReactComponent };